import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./user-management-modals.scss";

interface AddUserModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (user: any) => void;
}

const AddUserModal: React.FC<AddUserModalProps> = ({ open, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        role: "User",
        status: "Active",
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSave(formData);
        setFormData({
            firstName: "",
            lastName: "",
            email: "",
            role: "User",
            status: "Active",
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            className="user-management-modal-dialog"
        >
            <DialogTitle>
                <div className="modal-header">
                    <span>Add User</span>
                    <IconButton onClick={onClose} size="small" className="close-btn">
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                <form id="add-user-form" onSubmit={handleSubmit} className="user-modal-form">
                    <div className="form-row">
                        <div className="form-group">
                            <label>First Name <span className="required">*</span></label>
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    placeholder="Enter first name"
                                    value={formData.firstName}
                                    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Last Name <span className="required">*</span></label>
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    placeholder="Enter last name"
                                    value={formData.lastName}
                                    onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Email <span className="required">*</span></label>
                        <div className="input-wrapper">
                            <input
                                type="email"
                                placeholder="Enter email address"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Role <span className="required">*</span></label>
                        <div className="input-wrapper">
                            <select
                                value={formData.role}
                                onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                            >
                                <option value="Admin">Admin</option>
                                <option value="Provider">Provider</option>
                                <option value="User">User</option>
                                <option value="Preneed Planner">Preneed Planner</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Status <span className="required">*</span></label>
                        <div className="input-wrapper">
                            <select
                                value={formData.status}
                                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                    </div>
                </form>
            </DialogContent>
            <DialogActions>
                <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
                <button type="submit" form="add-user-form" className="save-btn">Add User</button>
            </DialogActions>
        </Dialog>
    );
};

export default AddUserModal;
